import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { useSelector, useDispatch } from 'react-redux';
import { actions } from 'store/batches';
import { ToolbarV2, TableComponentV2 } from 'components';
import { batchTableTitles } from 'constants.js';
import DisplayModal from 'components/DisplayModal';

const {
  getPaginatedBatches,
  getAttachmentFile,
  updateBatchFilters,
  resetBatchFilters
} = actions;

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  }
}));

const Batches = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const templates = useSelector((store) => store.batches.paginatedList);
  const filters = useSelector((store) => store.batches.filters);
  const isLoading = useSelector((store) => store.batches.gettingPaginated);

  const optionsToFilterType = [
    { name: 'type', value: 'HTML', checked: false },
    { name: 'type', value: 'PDF', checked: false }
  ];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentRow, setcurrentRow] = useState({});

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    dispatch(getPaginatedBatches({ force: true }));
  }, []);

  const getTransformedBatch = (row) => {
    return {
      'Batch Id': row.id,
      'Print Template Name': row.templateName,
      'Print Template Id': row.templateId,
      'Created On': row.createTime,
      'Events Count': row.eventsCount,
      'Processed Events Count': row.processedCount,
      'Retry Count': row.retryCount,
      Type: row.type,
      Status: row.status,
      ...(row.status === 'COMPLETED' && {
        'Time Taken': row.timeTaken,
        'Attachment Id': row.attachmentId
      }),
      ...(row.status === 'ABORTED' && {
        'Failure Reason': row.errReason
      })
    };
  };

  const getActionButtons = (template) => [
    {
      name: 'View Details',
      action: ['ACTION', () => onInfoClick(template)],
      hasModal: true
    },
    {
      name: 'Download',
      action: ['ACTION', () => onDownload(template)],
      ...(template.status !== 'COMPLETED' && {
        isDisabled: true,
        tooltipPlacement: 'left-start',
        tooltipTitle: 'Not available for download'
      }),
      ...(template.status === 'COMPLETED' && {
        isDisabled: template.canDownload ? false : true,
        tooltipPlacement: 'left-start',
        tooltipTitle: 'Not available for download'
      })
    },
    {
      name: 'Preview',
      action: ['ACTION', () => onPreview(template)],
      ...(template.status !== 'COMPLETED' && {
        isDisabled: true,
        tooltipPlacement: 'left-start',
        tooltipTitle: 'Not available for preview'
      }),
      ...(template.status === 'COMPLETED' && {
        isDisabled: template.canDownload ? false : true,
        tooltipPlacement: 'left-start',
        tooltipTitle: 'Not available for preview'
      })
      // },
      // Can be used later when endpoints are available
      // {
      //   name: 'Cancel',
      //   action: ['ACTION', () => onInfoClick(template)],
      //   ...(template.status !== "PROCESSING" && {
      //     isDisabled: true
      //   })
      // },
      // {
      //   name: 'Retry',
      //   action: ['ACTION', () => onInfoClick(template)],
      //   ...(template.status !== "ABORTED" && {
      //     isDisabled: true
      //   })
    }
  ];

  const onInfoClick = (row) => {
    let batchInfo = getTransformedBatch(row);
    setcurrentRow(batchInfo);
    setIsModalOpen((prev) => !prev);
  };

  const onDownload = (template) => {
    dispatch(
      getAttachmentFile({
        attachmentId: template.attachmentId,
        isDownload: true
      })
    );
  };

  const onPreview = (template) => {
    dispatch(
      getAttachmentFile({
        attachmentId: template.attachmentId,
        isDownload: false
      })
    );
  };

  const filterOptions = {
    filters: [
      {
        options: optionsToFilterType.map((option) => {
          if (filters?.filterTypes?.includes(option.value)) {
            option.checked = true;
          }
          return option;
        }),
        title: 'Type',
        values: filters?.filterTypes,
        onChange: (types) =>
          dispatch(updateBatchFilters({ filterTypes: types, pageNo: 0 }))
      }
    ],
    resetFilters: () => dispatch(resetBatchFilters())
  };

  const searchOptions = {
    searchPlaceholder: 'Search Print Templates',
    searchAction: (payload) => dispatch(updateBatchFilters(payload)),
    searchKey: 'searchInput',
    searchValue: filters?.searchInput || ''
  };

  return (
    <div className={classes.root}>
      <ToolbarV2
        searchOptions={searchOptions}
        filterOptions={filterOptions}
        buttonsGroup={[]}
        action={getPaginatedBatches({ force: true })}
      />
      <div className={classes.content}>
        <TableComponentV2
          isLoading={isLoading}
          tableTitles={batchTableTitles}
          onDoubleClickRow={(row) => onInfoClick(row)}
          actionButtonOptions={(row) => getActionButtons(row)}
          filteredRows={templates}
          action={getPaginatedBatches({ force: true })}
          filterValues={filters}
          filterAction={(payload) => dispatch(updateBatchFilters(payload))}
        />
      </div>
      <DisplayModal
        batch={currentRow}
        title={'Batch Details'}
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
        size="md"
      />
    </div>
  );
};

export default Batches;
